import {
  FETCH_FEATURE_FLAGS_REQUEST,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
  UPDATE_FEATURE_FLAG_REQUEST,
  UPDATE_FEATURE_FLAG_SUCCESS,
  UPDATE_FEATURE_FLAG_FAILURE,
  FETCH_FEATURE_FLAG_REQUEST,
  FETCH_FEATURE_FLAG_SUCCESS,
  FETCH_FEATURE_FLAG_FAILURE,
} from "./types";

export const fetchFeatureFlagsRequest = () => ({
  type: FETCH_FEATURE_FLAGS_REQUEST,
});

export const fetchFeatureFlagsSuccess = (items) => ({
  type: FETCH_FEATURE_FLAGS_SUCCESS,
  payload: items,
});

export const fetchFeatureFlagsFailure = (error) => ({
  type: FETCH_FEATURE_FLAGS_FAILURE,
  payload: error,
});

export const updateFeatureFlagRequest = ({ name, is_enabled }) => ({
  type: UPDATE_FEATURE_FLAG_REQUEST,
  payload: { name, is_enabled },
});

export const updateFeatureFlagSuccess = ({ name, flag }) => ({
  type: UPDATE_FEATURE_FLAG_SUCCESS,
  payload: { name, flag },
});

export const updateFeatureFlagFailure = ({ name, error }) => ({
  type: UPDATE_FEATURE_FLAG_FAILURE,
  payload: { name, error },
});

export const fetchFeatureFlagRequest = (name) => ({
  type: FETCH_FEATURE_FLAG_REQUEST,
  payload: { name },
});

export const fetchFeatureFlagSuccess = ({ name, flag }) => ({
  type: FETCH_FEATURE_FLAG_SUCCESS,
  payload: { name, flag },
});

export const fetchFeatureFlagFailure = ({ name, error }) => ({
  type: FETCH_FEATURE_FLAG_FAILURE,
  payload: { name, error },
});
